const sumArrayNumbers = (numbers: number[]) => {
	if (!Array.isArray(numbers) || numbers.length === 0) return 0;
	const filteredNumbers = numbers.filter(num => typeof num === 'number');
	return filteredNumbers.reduce((total, num) => total + num, 0);
};

export {sumArrayNumbers};
